import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import CI0303C from '../../components/CI/CI0303/Index';
function mapDispatchToProps(_ref) {
  var ci0303Info = _ref.ci0303Info;
  return {
    ci0303Info: ci0303Info
  };
}
var CI0303R = _Form.create()(CI0303C);
export default connect(mapDispatchToProps)(CI0303R);